/**
 * @file useWarehouseBins.ts
 * @description Ячейки склада для полей размещения (phase19.24 этап 1, шаг 1;
 * вынесено из `ReceiptItemForm`).
 *
 * Справочник может быть пуст — адресного хранения на складе ещё нет; тогда
 * поле «Ячейка» остаётся с одним «не задана». Ошибку запроса гасим тем же
 * пустым списком: форма приёмки не должна падать из-за справочника.
 *
 * Сводка содержимого (`withSummary`) не запрашивается: считать остатки ради
 * выпадающего списка — лишняя работа сервера на каждый ввод.
 */

import { useEffect, useState } from "react";

import { binsApi, type StorageBinDto } from "../../lib/api-bins";

export function useWarehouseBins(warehouseId: string): StorageBinDto[] {
  const [bins, setBins] = useState<StorageBinDto[]>([]);

  useEffect(() => {
    if (!warehouseId) return;
    let cancelled = false;
    binsApi
      .list({ warehouseId, withSummary: false })
      .then((data) => {
        if (!cancelled) setBins(data);
      })
      .catch(() => {
        if (!cancelled) setBins([]);
      });
    return () => {
      cancelled = true;
    };
  }, [warehouseId]);

  return bins;
}
